import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
/* empty css                     */
const LineItemContent = React.forwardRef(
  ({ body, children, className, title, ...rest }, ref) => {
    let content = children;
    if (!content) {
      content = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", className: "elements-line-item-content__title" }, title), /* @__PURE__ */ React.createElement("div", { className: "elements-line-item-content__body" }, body));
    }
    return /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("elements-line-item-content", className), ref }, content);
  }
);
LineItemContent.displayName = "LineItemContent";
export {
  LineItemContent as default
};
//# sourceMappingURL=LineItemContent.js.map
